module.exports = __webpack_public_path__ + "img/support_c2.95f5a637.png";